<template>
  <div id="components-modal-demo-position" ref="infoDialogContent">
    <a-modal
      v-model="modalVisible"
      centered
      :afterClose="() => (data = {})"
      class="modelClose"
      :footer="null"
      :width="940"
      :bodyStyle="bodyStyle"
    >
      <div id="box" style="position: relative; top: -25px"></div>
      <a-row>
        <a-col :span="2">
          <img src="@/assets/uploadIcon/pdf.svg" alt="" style="width: 30px; height: 36px" />
        </a-col>
        <a-col :span="21">
          <div style="position: relative">
            <div class="title" v-html="data.title"></div>
            <div class="sub-title" v-html="data.content"></div>
            <a-row style="margin-top: 29px">
              <div class="intro">来源：{{ data.source }}</div>
              <a-divider type="vertical" />
              <div class="intro">国家：{{ data.country }}</div>
              <a-divider type="vertical" />
              <div class="intro">语言：{{ data.languageName }}</div>
              <a-divider type="vertical" />
              <div class="intro">发布时间：{{ data.rawPublishTime }}</div>
            </a-row>
            <a-button
              style="position: absolute; right: 0; z-index: 9999; bottom: -5px"
              type="primary"
              @click="fileDownload(pdfUrl, 'pdf文件')"
              >下 载</a-button
            >
          </div>
        </a-col>
      </a-row>

      <a-spin size="large" :spinning="spinning">
        <div class="pdf" v-if="spinningxianshi">
          <div class="main" style="padding-top: 15px">
            <!-- <pdf
              ref="pdf"
              :src="pdfUrl"
              v-for="i in pageNum"
              :key="i"
              :page="i"
              :rotate="pageRotate"
              @num-pages="pageTotalNum = $event"
            >
            </pdf> -->
            <iframe
              id="iframe"
              :src="pdfUrl + '#toolbar=0'"
              ref="ifr"
              frameborder="0"
              width="100%"
              height="640px"
              scrolling="auto"
            ></iframe>
          </div>
          <!-- <div>{{ pageNum }}/{{ pageTotalNum }}</div> -->
          <!-- <button class="btn-def btn-pre" @click.stop="clock">顺时针</button>
        <button class="btn-def btn-next" @click.stop="counterClock">逆时针</button> -->
          <!-- <button class="btn-def btn-pre" @click.stop="prePage">上一页</button>
          <button class="btn-def btn-next" @click.stop="nextPage">下一页</button>
          <div>{{ pageNum }}/{{ pageTotalNum }}</div> -->
          <!-- <button :class="{ select: idx == 0 }" @touchstart="idx = 0" @touchend="idx = -1" @click="scaleD">放大</button>
        <button :class="{ select: idx == 1 }" @touchstart="idx = 1" @touchend="idx = -1" @click="scaleX">缩小</button>

        <div>进度：{{ loadedRatio }}</div>
        <div>页面加载成功: {{ curPageNum }}</div> -->
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
// import pdf from 'vue-pdf'
import axios from 'axios'
export default {
  components: {
    // pdf
  },
  data() {
    return {
      modalVisible: false,
      pdfUrl: '',
      pageNum: 0,
      pageTotalNum: 0,
      spinning: false,
      spinningxianshi: true,
      pageRotate: 0,
      loadedRatio: 0, // 加载进度
      curPageNum: 0,
      scale: 100, // 放大系数
      idx: -1,
      bodyStyle: {
        height: '810px',
        overflow: 'auto'
      },
      data: {}
    }
  },
  created() {},

  methods: {
    openModel(data) {
      this.$nextTick(() => {
        document.getElementById('box').scrollIntoView()
      })
      this.pdfUrl = data.documentUrl
      this.data = data
      this.spinning = true
      this.modalVisible = true
      this.$refs.infoDialogContent.scrollTop = 0
      setTimeout(() => {
        this.spinning = false
      }, 700)
    },
    // 下载PDF
    fileDownload(data, fileName) {
      let fileurl = data
      axios({
        methods: 'get',
        url: fileurl,
        responseType: 'arraybuffer'
      }).then((res) => {
        const blob = new Blob([res.data])
        const downloadHref = URL.createObjectURL(blob)
        let downloadLink = document.createElement('a')
        downloadLink.href = downloadHref
        downloadLink.download = `${fileName}.pdf`
        downloadLink.click()
      })
    },
    // 放大
    scaleD() {
      this.scale += 5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
    },

    // 缩小
    scaleX() {
      if (this.scale === 100) {
        return
      }
      this.scale += -5
      this.$refs.pdf.$el.style.width = parseInt(this.scale) + '%'
    },
    prePage() {
      var p = this.pageNum
      if (p === 1) {
        this.$message.error('已经浏览到第一页')
        return false
      }
      p = p > 1 ? p - 1 : this.pageTotalNum
      this.pageNum = p
    },
    nextPage() {
      var p = this.pageNum
      if (p === this.pageTotalNum) {
        this.$message.error('已经浏览到最后一页')
        return false
      }
      p = p < this.pageTotalNum ? p + 1 : 1
      this.pageNum = p
    },
    clock() {
      this.pageRotate += 90
    },
    counterClock() {
      this.pageRotate -= 90
    },
    password(updatePassword, reason) {
      updatePassword(prompt('password is "123456"'))
    },
    pageLoaded(e) {
      this.curPageNum = e
    },
    pdfError(error) {
      console.error(error)
    },
    pdfPrintAll() {
      this.$refs.pdf.print()
    },
    pdfPrint() {
      this.$refs.pdf.print(100, [1, 2])
    }
  }
}
</script>
<style scoped lang="less">
.title {
  margin-top: 4px;
  font-size: 18px;
  font-weight: 800;
  color: #333333;
  line-height: 14px;
}
.sub-title {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  line-height: 14px;
  margin-top: 10px;
}
.intro {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
  display: inline;
}
.modelClose /deep/ .ant-modal-footer {
  text-align: center;
  padding: 20px 16px;
}
.modelClose /deep/ .ant-modal-footer button + button {
  margin-left: 30px;
}
.formFormat /deep/ .ant-form-item {
  margin-bottom: 20px;
  padding-bottom: 0px !important;
}
</style>
